import {ChangeDetectionStrategy, Component, Inject, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ButtonModule} from '../button/button.module';
import {DialogModule} from '../dialog/dialog.module';

@Component({
  selector: 'mc-manage-group-confirm-dialog',
  standalone: true,
  imports: [ButtonModule, DialogModule],
  templateUrl: './manage-group-confirm-dialog.component.html',
  styleUrl: './manage-group-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageGroupConfirmDialogComponent implements OnInit {
  confirmDialogTitle: string;
  confirmDialogInfo: string;
  deleteButtonTitle: string;

  dialogRef = inject(MatDialogRef<ManageGroupConfirmDialogComponent>);

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {confirmDialogTitle: string; confirmDialogText?: string; deleteButtonTitle: string},
  ) {}

  ngOnInit() {
    this.confirmDialogTitle = this.data.confirmDialogTitle;
    this.confirmDialogInfo = this.data.confirmDialogText;
    this.deleteButtonTitle = this.data.deleteButtonTitle;
  }

  confirm() {
    this.dialogRef.close({confirm: true});
  }

  close(): void {
    this.dialogRef.close({confirm: false});
  }
}
